export { OneTrustLoaderService } from './lib/onetrust-loader.service';

export { provideOneTrust } from './lib/provide-one-trust';

export { OneTrustService } from './lib/one-trust.service';
